export default __webpack_public_path__ + "static/media/login.c49f96b0.png";